module.exports = __webpack_public_path__ + "static/media/future-me.6a2dae79.jpg";